import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_GOOGLE_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_GOOGLE_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_GOOGLE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_GOOGLE_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_GOOGLE_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_GOOGLE_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)
const storage = getStorage(app)
const database = getDatabase(app)
const analytics = getAnalytics(app)
const firestore = getFirestore(app)
const functions = getFunctions(app)
const auth = getAuth(app)

export { app, storage, database, firestore, analytics, functions, auth }
